import { render, staticRenderFns } from "./MetricTabsWithContent.vue?vue&type=template&id=ce6c5f54&scoped=true"
import script from "./MetricTabsWithContent.vue?vue&type=script&lang=ts"
export * from "./MetricTabsWithContent.vue?vue&type=script&lang=ts"
import style0 from "./MetricTabsWithContent.vue?vue&type=style&index=0&id=ce6c5f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6c5f54",
  null
  
)

export default component.exports